// Declare variables that are assumed to be on the page from other sources
// _LayoutLoggedIn.cshtml (see DynamicTranslations)
declare var TranslatedResources: any;
// Webtrack.cshtml
declare var $webtrackContainer: any;

// DON'T DELETE THIS!  THIS IS REQUIRED TO ADDRESS A BUG IN FIREFOX IN WHICH CHECKBOXES RETAIN THEIR CHECKSTATE WHEN THE PAGE IS REFRESHED
// -AS 2025: This is not technically a bug in FF but a behavior choice that doesn't align with other browsers.
//           We can proactively disable it using `autocomplete="off"` but that's a big ask to do retroactively for the site.
// Clear checkstate of all checkboxes
function ClearChecks() {
  $(":checkbox:checked").not(jQuery(".keepCheck")).prop("checked", false);
}
// Restrict user input in a text field
// create as many regular expressions here as you need:
const digitsOnly = /[1234567890]/g;
const integerOnly = /[0-9]/g;
const alphaOnly = /[A-Za-z]/g;
const usernameOnly = /[0-9A-Za-z\._-]/g;

// initialize keypress event for quantity boxes
// HACK: this functionality only works across the board (search results & title details) if restrictInput is fired after triggering the add.  At this point I cannot determine why. NB 20130128
function initAddToCartQuantityBox() {
  // assign onkeypress event handler to all quantity boxes to restrict the user input to numbers
  jQuery(".quantityBox").on("keypress", function (event) {
    if (event.keyCode == 13) {
      // update quantity in webtrack container
      updateQuantityForWebtrack($(this));

      //Find the 'Add to cart' button associated with this quantity box & trigger its click event to add the title to the cart
      jQuery(".btn.addToCart", $(this).parents(".addToCartForm")).trigger(
        "click",
      );
    }
    return restrictInput(this, event, digitsOnly);
  });

  // update quantity in webtrack collection for associated item id
  jQuery(".quantityBox").on("change", function () {
    if (typeof $webtrackContainer !== "undefined") {
      updateQuantityForWebtrack($(this));
    }
  });

  var updateQuantityForWebtrack = function (quantBox: JQuery<HTMLElement>) {
    var itemId = $(quantBox)
      .closest(".addToCartContainer")
      .find("input[name='ItemIdList']")
      .val();
    if (typeof itemId === "undefined") {
      // if this is not an add to cart quantity box (update all, etc.) do nothing
      return;
    }
    var quant = $(quantBox).val();
    $webtrackContainer.updateTitleQuantity(itemId, quant);
  };
}

// This function is used in conjunction with the localized .js files in "/Scripts/Internationalization/"
// We reference the file by the current language code to get the script level translations (Ex. DynamicTranslations.fr-ca.js)
function GetDynamicTranslation(resourceKey: string) {
  // get resource localezed for this file
  var translationDictionary = TranslatedResources;

  // ensure resource key is not null\empty
  if (resourceKey != null && resourceKey.length > 0) {
    // check for a localized translation
    if (translationDictionary.hasOwnProperty(resourceKey)) {
      return translationDictionary[resourceKey];
    }
  }
}

function restrictInput<T extends JQuery.KeyPressEvent | KeyboardEvent>(
  myfield: HTMLElement,
  e: T,
  restrictionType: RegExp,
) {
  if (!e) var e = window.event as T;
  var code;
  if (e.keyCode) code = e.keyCode;
  else if (e.which) code = e.which;
  var character = String.fromCharCode(code!);

  // if user pressed esc... remove focus from field...
  if (code == 27) {
    myfield.blur();
    return false;
  }

  // ignore if the user presses other keys
  // strange because code: 39 is the down key AND ' key...
  if (
    !e.ctrlKey &&
    code != 9 &&
    code != 8 &&
    code != 36 &&
    code != 37 &&
    code != 38 &&
    (code != 39 || (code == 39 && character == "'")) &&
    code != 40
  ) {
    return character.match(restrictionType);
  }
}

function RemoveNonAlphaNumeric(text: string) {
  ///<summary>
  ///Returns a version of the string input with all spaces removed.
  ///</summary>
  return text.replace(/[^a-zA-Z0-9]/g, "");
}

// This is NOT a polyfill. There is not currently a remove method, although filter can easily implement one.
if (!Array.prototype.remove) {
  Array.prototype.remove = function (item) {
    return jQuery.grep(this, function (value) {
      return value != item;
    });
  };
}

///<summary>Checks that a keypress is a valid one (non-symbol, non-alphabetic).  Does NOT check for numeric input</summary>
function isValidKeyInput(event: KeyboardEvent) {
  // Allow: backspace, delete, tab, escape and enter
  if (
    event.keyCode == 46 ||
    event.keyCode == 8 ||
    event.keyCode == 9 ||
    event.keyCode == 27 ||
    event.keyCode == 13 ||
    // Allow: Ctrl+A
    (event.keyCode == 65 && event.ctrlKey === true) ||
    // Allow: home, end, left, right
    (event.keyCode >= 35 && event.keyCode <= 39)
  ) {
    return true;
  }

  return false;
}

/*
 * Controller endpoints with [ValidateAntiForgeryToken] expect an antiforgery token to be included.
 * We render the token on every page so we can fetch it for use outside of Razor files.
 * See https://learn.microsoft.com/en-us/aspnet/core/security/anti-request-forgery#javascript for more info.
 */
function getRequestVerificationToken() {
  return document.querySelector<HTMLInputElement>(
    "#__AjaxAntiForgeryForm input[name=__RequestVerificationToken]",
  )?.value;
}

// Used for adding an antiforgery token to ajax posts
// Cribbed from stackoverflow.com/a/4074289
function AddAntiForgeryToken(data: Record<string, unknown>) {
  data = data || {};

  data.__RequestVerificationToken = getRequestVerificationToken();
  return data;
}

function AddAntiForgeryTokenToForm(formData: FormData): FormData {
  formData = formData || new FormData();

  formData.append(
    "__RequestVerificationToken",
    getRequestVerificationToken() ?? "",
  );

  return formData;
}

function AddAntiForgeryTokenToUrlSearchParams(
  searchParam: URLSearchParams,
): URLSearchParams {
  searchParam = searchParam || new URLSearchParams();

  searchParam.append(
    "__RequestVerificationToken",
    getRequestVerificationToken() ?? "",
  );

  return searchParam;
}

/*
Get a query string value for the given query string variable name, optionally seach the given queryString instead of the
pages query string.
*/
function GetQueryStringParam(name: string, queryString?: string) {
  if (!queryString) {
    queryString = window.location.href;
  }
  var matchResult = new RegExp("[?|&]" + name + "=([^&#]*)", "i").exec(
    queryString,
  );
  return (matchResult && matchResult[1]) || "";
}

function DecodeURIComponentWithSpaces(dataQueryParameter: string) {
  // replace instances of '+' with '%20' so the native decode method will know to use spaces
  dataQueryParameter = dataQueryParameter.replace(/[+]+/g, "%20");

  return decodeURIComponent(dataQueryParameter);
}

// Cribbed from https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
function isEmail(email: string) {
  var regex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(email);
}

// this function removes instances of special chars from the passed string
// removes: < > \ /
function cleanHtmlFromTerm(term: string) {
  while (term.search(/<+|>+|\/+|\+/) !== -1) {
    term = term.replace(/<+|>+|\/+|\\+/, "");
  }
  term = term.trim();
  return term;
}

function isPositiveInt(num: number | string) {
  return Number(num) >>> 0 === Number(num);
}

// javascript string.format equivalent
String.prototype.format = function () {
  var s = this,
    i = arguments.length;

  while (i--) {
    s = s.replace(new RegExp("\\{" + i + "\\}", "gm"), arguments[i]);
  }
  return s as string;
};

// Find the width of inner text
$.fn.textWidth = function () {
  var $this = $(this),
    text = $this.html();

  $this.html('<span class="unobtrusive">{0}</span>'.format(text));

  const width = $this.find("> span").width()!;

  $this.html(text);

  return width;
};

// Shrinks text that expands past the boundaries of its container width wise
// Warning: only guaranteed to work for elements where raw text is the element's child
$.fn.shrinkFitText = function (args?: {
  tolerancePx?: number;
  minFontSize?: number;
}) {
  args = args || {};
  args.tolerancePx = args.tolerancePx || 2;
  args.minFontSize = args.minFontSize || 9;

  if (!$(this).length) {
    return;
  }

  var $fullSelection = $(this),
    $singleElement = $($fullSelection[0]!),
    containerWidth = $singleElement.width()!;

  // If the text already fits inside the container don't do anything
  if ($singleElement.textWidth() <= containerWidth) {
    return;
  }

  var maxFont = parseFloat($singleElement.css("font-size").replace("px", "")),
    minFont = 1;

  // Binary search to an appropriate font size
  for (var resizeActionCap = 0; resizeActionCap <= 15; ++resizeActionCap) {
    var sizeDifference = containerWidth - $singleElement.textWidth();
    if (0 <= sizeDifference && sizeDifference <= args.tolerancePx) {
      break;
    }

    var midFont = minFont + (maxFont - minFont) / 2;
    $singleElement.css("font-size", midFont);

    if ($singleElement.textWidth() <= containerWidth) {
      minFont = midFont;
    } else {
      maxFont = midFont;
    }
  }

  $fullSelection.css(
    "font-size",
    Math.max(
      args.minFontSize,
      parseFloat($singleElement.css("font-size").replace("px", "")),
    ),
  );
};

// https://css-tricks.com/snippets/jquery/serialize-form-to-json/
$.serializeMPForm = function (frm) {
  var o: Record<string, string | string[]> = {};
  var a = $(frm).serializeArray();
  $.each(a, function () {
    const value = o[this.name];
    let newValue: string | string[];
    if (value) {
      if (!Array.isArray(value)) {
        newValue = [value];
      } else {
        newValue = value;
      }
      newValue.push(this.value || "");
    } else {
      newValue = this.value || "";
    }
    o[this.name] = newValue;
  });
  return o;
};

$.circleSpinner =
  '<div class="spinner--container blue">' +
  '<div class="spinner--circle spinner--rotate_01"></div>' +
  '<div class="spinner--circle spinner--rotate_02"></div>' +
  '<div class="spinner--circle spinner--rotate_03"></div>' +
  '<div class="spinner--circle spinner--rotate_04"></div>' +
  '<div class="spinner--circle spinner--rotate_05"></div>' +
  '<div class="spinner--circle spinner--rotate_06"></div>' +
  '<div class="spinner--circle spinner--rotate_07"></div>' +
  '<div class="spinner--circle spinner--rotate_08"></div>' +
  "</div>";

var color = {
  getRgba: function (color: string, alpha = 1) {
    return "rgba(" + color + "," + alpha + ")";
  },
};

export {
  ClearChecks,
  digitsOnly,
  integerOnly,
  alphaOnly,
  usernameOnly,
  initAddToCartQuantityBox,
  GetDynamicTranslation,
  restrictInput,
  RemoveNonAlphaNumeric,
  isValidKeyInput,
  AddAntiForgeryToken,
  AddAntiForgeryTokenToForm,
  AddAntiForgeryTokenToUrlSearchParams,
  GetQueryStringParam,
  DecodeURIComponentWithSpaces,
  isEmail,
  cleanHtmlFromTerm,
  isPositiveInt,
  color,
};
